import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FreelancerOnboardingStep } from '../../components/';
import {
  enableNextButton,
  disableNextButton,
  setCurrentOnboardingStep,
  setNextOnboardingStep,
  setPrevOnboardingStep,
} from '../../store/actions/FreelancerOnboarding';
import {
  updateAccount,
  updateAccountSuccess,
} from '../../store/actions/Authentication';
import {
  getNextFreelancerOnboardingStep,
  getPrevFreelancerOnboardingStep,
  removeEmptyObjects,
  routesAction,
} from '../../shared/helpers';

class FreelancerOnboarding extends Component {
  constructor(props) {
    super(props);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleGoToAnswer = this.handleGoToAnswer.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleOtherOptionsInputChange = this.handleOtherOptionsInputChange.bind(
      this,
    );
    this.handleSelectCard = this.handleSelectCard.bind(this);
  }

  componentDidMount() {
    const { currentOnboardingStep } = this.props;
    const onboardingStep = this.getValidCurrentOnboardingStep(
      currentOnboardingStep,
    );
    this.props.dispatchSetCurrentOnboardingStep(onboardingStep);
  }

  getValidCurrentOnboardingStep(currentOnboardingStep) {
    return currentOnboardingStep === 'dashboard'
      ? 'edit_profile'
      : currentOnboardingStep;
  }

  handleGoToAnswer(onboardingStep) {
    this.props.dispatchSetCurrentOnboardingStep(onboardingStep);
  }

  sanitizeExperiences(experiences) {
    const { dispatchSetFormValues, formValues } = this.props;

    const sanitizedExperiences = removeEmptyObjects(experiences);

    dispatchSetFormValues({
      ...formValues,
      experiences: sanitizedExperiences,
    });
  }

  handlePrevStep(event) {
    event.preventDefault();
    this.props.dispatchEnableNextButton();
    const {
      currentOnboardingSteps,
      formValues: { experiences },
    } = this.props;
    this.sanitizeExperiences(experiences);
    this.props.dispatchSetPrevOnboardingStep();
    const [
      firstStep,
    ] = currentOnboardingSteps.freelancer_onboarding.freelancerSteps.map(
      step => step.key,
    );
    if (this.props.currentOnboardingStep === firstStep) {
      this.props.history.push(routesAction.default());
    }
    this.updatePortfolioPath(getPrevFreelancerOnboardingStep);
  }

  handleSelectCard(card) {
    const { formValues } = this.props;
    this.props.dispatchSetFormValues({
      ...formValues,
      project_type: card,
    });
  }

  handleUpdateAccount = () => {
    const {
      formValues,
      currentOnboardingStep,
      dispatchAccountUpdate,
    } = this.props;
    return dispatchAccountUpdate({
      ...formValues,
      current_step: currentOnboardingStep,
    });
  };

  handleNextStep(event) {
    event.preventDefault();
    const {
      currentOnboardingStep,
      formValues,
      dispatchSetNextOnboardingStep,
      history: { push },
    } = this.props;

    this.handleUpdateAccount();

    if (currentOnboardingStep === 'tagline') {
      push(routesAction.default());
      return;
    }

    dispatchSetNextOnboardingStep(formValues);
    this.updatePortfolioPath(getNextFreelancerOnboardingStep);
  }

  handleAddAnotherExperience = () => this.handleUpdateAccount();

  updatePortfolioPath(getStep) {
    const { currentOnboardingSteps, currentOnboardingStep } = this.props;

    const nextStep = getStep(currentOnboardingStep);
    const {
      key,
    } = currentOnboardingSteps.freelancer_onboarding.freelancerSteps.find(
      step => step.key === nextStep,
    );

    this.props.history.push(routesAction.freelancerOnboarding(key));
  }

  handleInputChange({ values, errors }) {
    if (!isEmpty(errors)) {
      this.props.dispatchDisableNextButton();
    } else {
      this.props.dispatchEnableNextButton();
      this.props.dispatchSetFormValues(values);
    }
  }

  handleOtherOptionsInputChange(event) {
    const { name, value } = event.target;
    const { formValues } = this.props;
    this.props.dispatchSetFormValues({
      ...formValues,
      [name]: value,
    });
  }

  handleCheckboxChange(event, checkbox) {
    const { formValues } = this.props;
    const { skills } = formValues;
    const { value, checked } = checkbox;

    const updatedSkills = checked
      ? [...skills, value]
      : skills.filter(s => s !== value);

    this.props.dispatchSetFormValues({
      ...formValues,
      skills: updatedSkills,
    });
  }

  render() {
    const {
      isNextEnabled,
      currentOnboardingStep,
      currentOnboardingSteps,
      formValues,
    } = this.props;

    const onboardingStep = this.getValidCurrentOnboardingStep(
      currentOnboardingStep,
    );

    return (
      <FreelancerOnboardingStep
        isNextEnabled={isNextEnabled}
        formValues={formValues}
        handleGoToAnswer={this.handleGoToAnswer}
        handleNextStep={this.handleNextStep}
        handlePrevStep={this.handlePrevStep}
        handleAddAnotherExperience={this.handleAddAnotherExperience}
        currentOnboardingStep={onboardingStep}
        currentOnboardingSteps={currentOnboardingSteps}
        handleInputChange={this.handleInputChange}
        handleCheckboxChange={this.handleCheckboxChange}
        handleOtherOptionsInputChange={this.handleOtherOptionsInputChange}
        handleSelectCard={this.handleSelectCard}
      />
    );
  }
}

const mapStateToProps = state => {
  const currentOnboardingSteps = state.freelancer;

  const { currentStep: currentOnboardingStep } = currentOnboardingSteps;

  const { user } = state.authentication;

  return {
    isNextEnabled: state.freelancer.isNextEnabled,
    currentOnboardingSteps,
    currentOnboardingStep,
    formValues: user,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchSetNextOnboardingStep: formValues => {
    dispatch(setNextOnboardingStep(formValues));
  },
  dispatchSetPrevOnboardingStep: () => {
    dispatch(setPrevOnboardingStep());
  },
  dispatchSetCurrentOnboardingStep: onboardingStep => {
    dispatch(setCurrentOnboardingStep(onboardingStep));
  },
  dispatchAccountUpdate: formValues => dispatch(updateAccount(formValues)),
  dispatchSetFormValues: formValues => {
    dispatch(updateAccountSuccess(formValues));
  },
  dispatchEnableNextButton: () => dispatch(enableNextButton()),
  dispatchDisableNextButton: () => dispatch(disableNextButton()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FreelancerOnboarding);

FreelancerOnboarding.propTypes = {
  isNextEnabled: PropTypes.bool,
  currentOnboardingStep: PropTypes.string,
  currentOnboardingSteps: PropTypes.object,
  dispatchSetNextOnboardingStep: PropTypes.func,
  dispatchSetPrevOnboardingStep: PropTypes.func,
  dispatchSetCurrentOnboardingStep: PropTypes.func,
  dispatchSetFormValues: PropTypes.func,
  dispatchAccountUpdate: PropTypes.func,
  formValues: PropTypes.object,
  history: PropTypes.object,
  dispatchEnableNextButton: PropTypes.func,
  dispatchDisableNextButton: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/containers/FreelancerOnboarding/FreelancerOnboarding.js